import { Box } from '@factorialco/deprecated-design-system'
import { F0AvatarList, PersonAvatarVariant } from '@factorialco/f0-react'
import { TrackReferenceOrPlaceholder } from '@livekit/components-react'
import { Track } from 'livekit-client'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useMeeting } from 'modules/meetings/lib/hooks/useMeeting'

interface HiddenTracksProps {
  isSmallMode: boolean
  initialTracks: TrackReferenceOrPlaceholder[]
  tracks: TrackReferenceOrPlaceholder[]
  isFocusActive: boolean
}

export const HiddenTracks = ({
  isSmallMode,
  initialTracks,
  tracks,
  isFocusActive,
}: HiddenTracksProps) => {
  const { meeting } = useMeeting()
  const attendees = meeting?.attendees || []

  const hiddenTracks = initialTracks.filter((track) => !tracks.includes(track))

  const avatars: PersonAvatarVariant[] = hiddenTracks.map((track) => {
    const isScreenShare = track.source === Track.Source.ScreenShare
    const participantId = track.participant.identity
    const attendee = attendees.find(
      ({ employee }) => Number(employee?.id) === Number(participantId)
    )
    return {
      firstName: attendee?.employee?.firstName || i18n.t('meetings.unknown_participant'),
      lastName: `${attendee?.employee?.lastName || ''}${
        isScreenShare ? ` (${i18n.t('meetings.room.screen_share')})` : ''
      }`,
      type: 'person',
      src: buildUrl(attendee?.employee?.avatar?.url),
    }
  })

  return (
    <Box
      height="full"
      width="full"
      background="grey200"
      alignItems="center"
      justifyContent="center"
      borderRadius={{ all: 'abs016' }}
      padding="s16"
      overflowX="hidden"
    >
      <F0AvatarList
        avatars={avatars}
        type="person"
        size={isFocusActive || isSmallMode ? 'sm' : 'md'}
        max={isFocusActive || isSmallMode ? 1 : 3}
      />
    </Box>
  )
}
